import * as React from 'react';
import { Button } from "primereact/button";
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { InactiveIngredientFilterSettingsModel } from "../../../models/inactiveIngredient/inactiveIngredientFilterSettingsModel";
import AlphabeticalFilter from '../../../common/components/alphabeticalFilter/alphabeticalFilter';

interface IProps {
    onSearchClick: any,
    totalRecordsCount: number
}

interface IState {
    inactiveIngredientSettings: InactiveIngredientFilterSettingsModel,
    selectedType: null,
    selectedGroup: null,
    filterText: string
}

export class InactiveIngredientFilter extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props);
        this.state = {
            inactiveIngredientSettings: new InactiveIngredientFilterSettingsModel(),
            selectedType: null,
            selectedGroup: null,
            filterText: ''
        };
    }

    handleAlphaIndexChange = (letter: string) => {
        const currentSettings: InactiveIngredientFilterSettingsModel = { ...this.state.inactiveIngredientSettings };
        currentSettings.inactiveIngredienName = '';
        currentSettings.alphaIndex = letter;
        const fiterText = this.generateFilterText(currentSettings);
        this.setState({
            inactiveIngredientSettings: { ...currentSettings },
            filterText: fiterText
        });
        this.handleSearchButtonClick(currentSettings);
    }

    handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name;

        const currentSettings: InactiveIngredientFilterSettingsModel = { ...this.state.inactiveIngredientSettings };
        currentSettings[name] = value;
        const fiterText = this.generateFilterText(currentSettings);
        this.setState({
            inactiveIngredientSettings: { ...currentSettings },
            filterText: fiterText
        });
    }

    generateFilterText = (settings: InactiveIngredientFilterSettingsModel) => {
        let result = '';

        if (settings.alphaIndex) {
            result += "Start with <strong>'" + settings.alphaIndex + "'</strong>, "
        }
        if (settings.inactiveIngredienName) {
            result += "Name <strong>'" + settings.inactiveIngredienName + "'</strong>, "
        }

        return result.substr(0, result.length - 2);
    }

    handleSearchButtonClick = (settings) => {
        this.props.onSearchClick(settings);
    }

    handleClearButtonClick = () => {
        this.setState({
            inactiveIngredientSettings: new InactiveIngredientFilterSettingsModel(),
            filterText: ''
        });
        this.handleSearchButtonClick(new InactiveIngredientFilterSettingsModel());
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSearchButtonClick(this.state.inactiveIngredientSettings)
        }
    }

    render() {
        return (
            <Toolbar style={{ marginBottom: '10px' }}>
                <AlphabeticalFilter
                    handleAlphaIndexChange={this.handleAlphaIndexChange}
                    filters={['en', 'bg']}
                />
                <div>
                    <InputText
                        onKeyPress={(e) => this.handleKeyPress(e)}
                        style={{ marginRight: "10px", marginBottom: "5px" }}
                        name="inactiveIngredienName"
                        placeholder="Name"
                        onChange={this.handleChange}
                        value={this.state.inactiveIngredientSettings && this.state.inactiveIngredientSettings.inactiveIngredienName ?
                            this.state.inactiveIngredientSettings.inactiveIngredienName : ''}
                    />
                </div>
                <div>
                    <div style={{ float: "left", paddingTop: "5px", marginBottom: "5px" }}>
                        Result: <strong>{this.props.totalRecordsCount}</strong>
                        {this.state.filterText ? ', ' : ''}
                        <span dangerouslySetInnerHTML={{ __html: this.state.filterText }}></span>
                    </div>
                    <div style={{ float: "right" }}>
                        <div>
                            <Button
                                className="p-button-raised"
                                icon="pi pi-filter"
                                style={{ marginRight: "10px" }}
                                label="Filter"
                                onClick={() => this.handleSearchButtonClick(this.state.inactiveIngredientSettings)}
                            />
                            <Button
                                className="p-button-secondary p-button-raised"
                                label="Clear"
                                icon="pi pi-times"
                                onClick={() => this.handleClearButtonClick()}
                            />
                        </div>
                    </div>
                </div>
            </Toolbar>
        )
    }
}

export default InactiveIngredientFilter;
